import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBookOpen, faLayerGroup } from "@fortawesome/free-solid-svg-icons";
import StatusBadge from "../Badges/StatusBadge";
import FinalExamSourceIcon from "../Badges/FinalExamSourceIcon";
import { roundScore } from "../../Utilities/moduleHelper";
import { formatDate } from "../../Utilities/dateUtils";
import { FINAL_EXAM_TYPE } from "../../constants/ConstantVars";

// The cells a student's Gy25 final exam variant shows in every result table:
// name with source and main exam/retest icon, status, score and last run.
// Row ids, buttons and the remaining columns belong to each table.
export default function buildFinalExamVariantCells(variant, type, intl) {
  const isParent = type === FINAL_EXAM_TYPE.PARENT;

  return {
    name: (
      <span className={isParent ? "" : "ms-4"}>
        <FinalExamSourceIcon
          isFromAnotherSchool={variant.isFromAnotherSchool}
          isFromAnotherClass={variant.isFromAnotherClass}
        />
        <span
          title={intl.formatMessage({ id: isParent ? "MainExam" : "Retest" })}
        >
          <FontAwesomeIcon
            icon={isParent ? faBookOpen : faLayerGroup}
            className="exam-icon me-2 text-primary"
          />
        </span>
        {variant.name}
      </span>
    ),
    // A main exam derived from a retest was not taken by the student.
    status: variant.isDerivedParent ? null : (
      <StatusBadge status={variant.status} isGy25FinalExam={true} />
    ),
    score:
      variant.score != null
        ? `${roundScore(variant.score)}/${variant.maxScore ?? ""} (${variant.scoreInPercent}%)`
        : null,
    lastRun: variant.lastRun ? formatDate(variant.lastRun, "PPp") : null,
  };
}
